import { reactive } from "@vue/reactivity"

const states = reactive({
    loginInfo: null,
    isNotAuth: false,
})

const mutations = {
    setLoginInfo: data => {
        states.loginInfo = data;
    },
    setIsNotAuth: bool => {
        states.isNotAuth = bool;
    }
}

export default {
    states,
    mutations
}